/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const BurgerMenu = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 24 24">
    <rect y="3" width="24" height="3" rx="1.5" fill="#2F3037" />
    <rect y="10" width="24" height="3" rx="1.5" fill="#2F3037" />
    <rect y="17" width="24" height="3" rx="1.5" fill="#2F3037" />
  </BaseSvgIcon>
)

export default BurgerMenu
